/*
 * @Author: cx
 * @Date: 2020-08-20 16:40:40
 * @Last Modified by: cx
 * @Last Modified time: 2020-08-27 15:12:37
 */

const install = function (Vue) {
  Vue.filter('brightnessFormula', value => {
    if (!value) return 0
    let val = 0
    if (value <= 60) {
      const a = 9.132e+4
      const b = 0.0423
      const c = -9.132e+4
      const d = 0.04229
      val = Math.floor(a * Math.exp(b * value) + c * Math.exp(d * value))
    } else {
      const a = 5.369
      const b = 0.0835
      const c = 0
      const d = -2.036
      val = Math.floor(a * Math.exp(b * value) + c * Math.exp(d * value))
    }
    return val
  })
}

export default install
